import type { Visualizer } from './types';
import { clearBg, drawHud } from './types';

export const bloomViz: Visualizer = {
  id: 'bloom',
  label: 'Neon Bloom',
  draw(frame) {
    const { ctx, w, h, bands, freq, t } = frame;
    clearBg(ctx, w, h, 0.3);
    const cx = w / 2;
    const cy = h / 2;
    const petals = 48;
    for (let i = 0; i < petals; i++) {
      const f = freq[Math.floor((i / petals) * freq.length)] / 255;
      const ang = (i / petals) * Math.PI * 2 + t * 0.4;
      const r = Math.min(w, h) * (0.12 + f * 0.28 + bands.energy * 0.12);
      const x = cx + Math.cos(ang) * r;
      const y = cy + Math.sin(ang) * r * 0.85;
      const rad = 6 + f * 28 + bands.kick * 10;
      const g = ctx.createRadialGradient(x, y, 0, x, y, rad);
      g.addColorStop(0, `hsla(${280 + i * 3 + bands.highs * 40}, 95%, 70%, ${0.55 + f * 0.4})`);
      g.addColorStop(0.45, `hsla(${190 + i * 2}, 90%, 55%, ${0.25 + f * 0.25})`);
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(x, y, rad, 0, Math.PI * 2);
      ctx.fill();
    }
    drawHud(frame);
  },
};
